export const LIVE_TOUR_OPERATOR_LIST_START = "LIVE_TOUR_OPERATOR_LIST_START";
export const LIVE_TOUR_OPERATOR_LIST_SUCCESS =
  "LIVE_TOUR_OPERATOR_LIST_SUCCESS";
export const LIVE_TOUR_OPERATOR_LIST_ERROR = "LIVE_TOUR_OPERATOR_LIST_ERROR";

export const TOUR_PRIORITY_DATA_START = "TOUR_PRIORITY_DATA_START";
export const TOUR_PRIORITY_DATA_SUCCESS = "TOUR_PRIORITY_DATA_SUCCESS";
export const TOUR_PRIORITY_DATA_ERROR = "TOUR_PRIORITY_DATA_ERROR";
